/*
 * @Author: Gang Jiang 
 * @Date: 2024-09-13 09:35:00 
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2024-11-23 14:22:27
 */

<template>
  <div
    ref="zjdgx"
    class="advertisers"
  >
    <div class="bread-crumb">
      Advertisers
    </div>
    <h2>Advertisers</h2>
    <div class="content">
      <a-spin :spinning="isLoading">
        <a-form
          class="filter"
          :model="filter"
          @submit="searchAdvertiser()"
        >
          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-item label="Advertiser ID">
                <a-input
                  v-model:value="filter.advertiserId"
                  placeholder="Please enter"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="Advertiser name">
                <a-input
                  v-model:value="filter.advertiserName"
                  placeholder="Please enter"
                />
              </a-form-item>
            </a-col>
            <a-col
              :span="8"
              style="text-align: center"
            >
              <a-button
                type="primary"
                html-type="submit"
              >
                Search
              </a-button>
              <a-button
                type="default"
                html-type="reset"
                style="margin-left: 20px"
                @click="resetFilter"
              >
                Reset
              </a-button>
              <span
                style="
                  cursor: pointer;
                  width: 61px;
                  margin-left: 20px;
                  display: inline-block;
                  text-align: left;
                "
                @click="expand = !expand"
              >{{ expand ? 'Fold' : 'Unfold' }} <UpOutlined v-if="expand" />
                <DownOutlined
                  v-else
                /></span>
            </a-col>
          </a-row>
          <a-row
            v-if="expand"
            :gutter="24"
          >
            <a-col :span="8">
              <a-form-item label="Affiliate MID">
                <a-input
                  v-model:value="filter.affiliateMid"
                  placeholder="Please enter"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="Affiliate">
                <a-select
                  v-model:value="filter.affiliateId"
                  placeholder="Select"
                  :options="affiliateList"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="Create Time">
                <a-range-picker
                  v-model:value="filterDate"
                  width="220"
                  :placeholder="['Start Time', 'End Time']"
                  @change="setFilterDate"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row
            v-if="expand"
            :gutter="24"
          >
            <a-col :span="8">
              <a-form-item label="Advertiser Region">
                <a-select
                  v-model:value="filter.regionId"
                  placeholder="Select"
                  :options="regionList"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="Category">
                <a-select
                  v-model:value="filter.categoryId"
                  placeholder="Select"
                  :options="categoryList"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="Display Status">
                <a-radio-group v-model:value="filter.displayStatus">
                  <a-radio value="active">
                    Active
                  </a-radio>
                  <a-radio value="inactive">
                    Inactive
                  </a-radio>
                </a-radio-group>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
        <div class="advertiser-list">
          <div class="header">
            <p class="h2">
              Advertisers List
            </p>
            <div class="wrapper">
              <a
                class="guide"
                href="https://docs.google.com/document/d/1786oQMevJNQFNnlt41LEVYg3AJF-YqTr47D8UIjPbxY/edit?usp=sharing"
                target="_blank"
              >Guide &gt;</a>
              <a
                href="/#/advertiser/new"
              ><a-button type="primary">+ Add advertiser</a-button></a>
            </div>
          </div>
          <a-table
            :data-source="advertiserList"
            :columns="columns"
            :scroll="{ x: 1600 }"
            :pagination="advertiserPagination"
            @change="onTableChange"
          >
            <template #bodyCell="{ column, record }">
              <template v-if="column.key === 'actions'">
                <div class="actions">
                  <a
                    class="view"
                    :href="'/#/advertiser/detail/' + record.id"
                  >View</a>
                  <a
                    class="edit"
                    :href="'/#/advertiser/edit/' + record.id"
                  >Edit</a>
                  <a
                    class="edit-affiliate"
                    :href="
                      '/#/affiliate/edit/' +
                        record.id +
                        (record.affiliate?.affiliateStatus === 'active'
                          ? '?id=' + record.affiliate.id
                          : '')
                    "
                  >Edit Affiliate</a>
                  <a
                    class="log"
                    href="javascript:;"
                    @click="setShowLogModalId(record.id)"
                  >Log</a>
                </div>
              </template>
              <template v-else-if="column.key === 'advertiserName'">
                <a
                  v-if="record.homepage"
                  :href="record.homepage"
                  target="_blank"
                >{{
                  record.advertiserName
                }}</a>
                <span v-else>{{ record.advertiserName }}</span>
              </template>
              <template v-else-if="column.key === 'createTime'">
                <span>{{
                  moment(record.createTime).format('YYYY-MM-DD HH:mm:ss')
                }}</span>
              </template>
              <template v-else-if="column.key === 'commissionOverall'">
                <span
                  :class="
                    'overall' +
                      (record.affiliate?.hasCommissionDetails
                        ? ' has-commission'
                        : '')
                  "
                  @click="
                    showCommissionDetail(
                      record.affiliate?.advertiserAffiliateRelationId
                    )
                  "
                >{{ record.affiliate?.commissionOverview || '-' }}</span>
              </template>
              <template v-else-if="column.key === 'displayStatus'">
                <span :class="'status ' + record.displayStatus">{{
                  record.displayStatus
                }}</span>
              </template>
              <template v-else-if="column.key === 'affiliateStatus'">
                <span
                  :class="
                    (record.affiliate ? 'status ' : '') +
                      record.affiliate?.affiliateStatus
                  "
                >{{ record.affiliate?.affiliateStatus || '-' }}</span>
              </template>
            </template>
          </a-table>
        </div>
      </a-spin>
    </div>
    <a-modal
      v-model:open="showCommissionList.length"
      :get-container="() => $refs.zjdgx"
      title="Commision Details"
      :width="1000"
      :footer="null"
      class="commission-detail-modal"
      @ok="showCommissionList = []"
      @cancel="showCommissionList = []"
    >
      <CommissionDetail :commission-list="showCommissionList" />
    </a-modal>
    <LogModal
      v-if="showLogModal"
      :id="showLogId"
      :container="$refs.zjdgx"
      show-affiliate-log-id="-1"
      @hideLogModal="hideLogModal"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import moment from 'moment'
import { message } from 'ant-design-vue'
import { advertiser } from '../../server/index'
import LogModal from '../../components/logModal.vue'
import { DownOutlined, UpOutlined } from '@ant-design/icons-vue'
import CommissionDetail from '../../components/commissionDetail.vue'
import { useRoute, useRouter } from 'vue-router'

const route = useRoute()
const router = useRouter()

const columns = [
  {
    title: 'Advertiser ID',
    dataIndex: 'id',
    key: 'id',
    width: 120,
    fixed: 'left',
  },
  {
    title: 'Display Status',
    dataIndex: 'displayStatus',
    key: 'displayStatus',
    width: 130,
    fixed: 'left',
  },
  {
    title: 'Advertiser name',
    dataIndex: 'advertiserName',
    key: 'advertiserName',
    width: 180,
    fixed: 'left',
  },
  {
    title: 'Advertiser Region',
    dataIndex: 'advertiserRegion',
    width: 152,
    key: 'advertiserRegion',
  },
  {
    title: 'Assigned AM',
    dataIndex: 'assignedAm',
    width: 120,
    key: 'assignedAm',
  },
  {
    title: 'Category',
    dataIndex: 'category',
    width: 180,
    key: 'category',
  },
  {
    title: 'Domain',
    dataIndex: 'domain',
    width: 180,
    key: 'domain',
  },
  {
    title: 'Affiliate',
    dataIndex: 'affiliate',
    width: 180,
    key: 'affiliate',
    customRender: (item) => {
      return item.record.affiliate?.name || '-'
    },
  },
  {
    title: 'Affiliate PID',
    dataIndex: 'pid',
    key: 'pid',
    width: 110,
    customRender: (item) => {
      return item.record.affiliate?.affiliatePid || '-'
    },
  },
  {
    title: 'Affiliate MID',
    dataIndex: 'mid',
    key: 'mid',
    width: 110,
    customRender: (item) => {
      return item.record.affiliate?.affiliateMid || '-'
    },
  },
  {
    title: 'Affiliate Region',
    dataIndex: 'affiliateRegion',
    key: 'affiliateRegion',
    width: 134,
    customRender: (item) => {
      return item.record.affiliate?.affiliateRegion || '-'
    },
  },
  {
    title: 'Affiliate Status',
    dataIndex: 'affiliateStatus',
    key: 'affiliateStatus',
    width: 132,
    customRender: (item) => {
      return item.record.affiliate?.affiliateStatus || '-'
    },
  },
  {
    title: 'Commission overview',
    dataIndex: 'commissionOverall',
    key: 'commissionOverall',
    width: 179,
  },
  {
    title: 'Advertiser Create Time',
    dataIndex: 'createTime',
    key: 'createTime',
    width: 188,
  },
  {
    title: 'Actions',
    dataIndex: 'actions',
    key: 'actions',
    width: 220,
    fixed: 'right',
  },
]
const isLoading = ref(false) // 是否加载商家列表
const filterDate = ref([null, null])
const expand = ref(false)
const showLogId = ref(-1)
const regionList = ref([])
const categoryList = ref([])
const affiliateList = ref([])
const showLogModal = ref(false)
const advertiserList = ref(null)
const showCommissionList = ref([])
const advertiserPagination = ref({
  current: 1,
  pageSize: 200,
  total: 0,
  showSizeChanger: false,
  onChange: (page) => {
    filter.value.page = page
    router
    getList()
  },
})
const filter = ref({
  page: parseInt(route.query.page) || 1,
  size: 200,
  advertiserId: null,
  advertiserName: null,
  affiliateId: null,
  affiliateMid: null,
  regionId: null,
  categoryId: null,
  displayStatus: null,
  beginTime: null,
  endTime: null,
})

const onTableChange = (pagination) => {
  // 更新 URL 查询参数
  router.push({
    path: route.path,
    query: {
      page: pagination.current,
    },
  })
}
const fetchData = async (
  action = 'getAffiliateList',
  varName,
  errorKey = 'affiliate'
) => {
  const res = await advertiser[action]()

  if (res.success) {
    varName.value = res.data.map((item) => {
      return {
        value: item.id,
        label: item.name,
      }
    })
  } else {
    message.error(
      `获取${errorKey}列表失败, 页面将会在3秒后返回到Advertiser列表页面。`
    )
  }
}
fetchData('getRegionList', regionList, 'region')
fetchData('getCategoryList', categoryList, 'category')
fetchData('getAffiliateList', affiliateList)

const searchAdvertiser = () => {
  filter.value.page = 1
  getList()
}
const getList = () => {
  const params = { ...filter.value }

  Object.keys(filter.value).forEach((key) => {
    if (!params[key]) {
      delete params[key]
    }
  })
  isLoading.value = true

  advertiser.getList(params).then((res) => {
    isLoading.value = false
    advertiserList.value = res.data
    advertiserPagination.value.current = filter.value.page

    advertiserPagination.value.total = res.total
  })
}
const showCommissionDetail = (advertiserAffiliateRelationId) => {
  if (advertiserAffiliateRelationId) {
    advertiser.commissionDetail(advertiserAffiliateRelationId).then((res) => {
      if (res.success) {
        showCommissionList.value = res.data
      } else {
        message.error('Network error, try again.')
      }
    })
  }
}
getList()

const resetFilter = () => {
  Object.keys(filter.value).forEach((key) => {
    if (key !== 'page' && key != 'size') {
      filter.value[key] = null
    } else if (key === 'page') {
      filter.value[key] = 1
    }
  })
  filterDate.value = [null, null]
  getList()
}
const setFilterDate = (values) => {
  filter.value.beginTime = values[0].startOf('date').valueOf()
  filter.value.endTime = values[1].endOf('date').valueOf()
}

// log相关代码
const setShowLogModalId = (id) => {
  showLogId.value = id
  showLogModal.value = true
}
const hideLogModal = () => {
  showLogId.value = -1
  showLogModal.value = false
}
</script>

<style lang="less" scoped>
.advertisers {
  margin-bottom: 20px;
  .h2 {
    font-size: 16px;
    font-weight: 500;
    padding: 20px 0 0 20px;
  }
  :deep(.ant-modal) {
    .ant-table {
      &-container {
        border-inline-start: none !important;
      }
      table {
        border-top: none !important;
      }
      &-cell:last-of-type {
        border-inline-end: none !important;
      }
    }
  }
  .content {
    padding: 0 10px;
  }
}
.filter {
  padding: 20px 20px 0;
  border-bottom: 1px solid #ebebeb;
  :deep(.ant-form-item-row) {
    width: 100%;
  }
}
.ant-form-item {
  display: flex;
  :deep(&-label) {
    width: 128px;
    color: #ff285a;
  }
}
.advertiser-list {
  .header {
    display: flex;
    align-items: center;
    padding-right: 20px;
    justify-content: space-between;
  }
  .guide {
    margin-right: 20px;
  }
  .has-commission {
    cursor: pointer;
    color: #1677ff;
    text-decoration: underline;
    &:hover {
      color: #ff285a;
    }
  }
  .actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    > a {
      user-select: none;
      color: #1677ff;
      &:hover {
        color: #ff285a;
      }
      &:not(:last-of-type) {
        margin-right: 10px;
      }
    }
  }
  :deep(.ant-table) {
    &-thead .ant-table-cell {
      white-space: nowrap;
    }
  }
}
</style>